import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe} from "@angular/common";
import { RouterModule } from "@angular/router";
import { HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule} from "@angular/forms";
import { CallbackPipe } from "../pipe/callback.pipe";
import { IonicModule } from "@ionic/angular";
import { AuthInterceptor } from "../interceptor/auth.interceptor";
import { AppSharedLibsModule} from "./app-shared-libs.module";
import { OnlyNumber} from "../directives/only-number.directive";
import { RelativeTime} from "../pipe/relative-time.pipe";
import { IonicTimepickerModule } from '@logisticinfotech/ionic-timepicker';
import { SweetAlert2Module} from "@sweetalert2/ngx-sweetalert2";
import { NgSelectModule} from "@ng-select/ng-select";
import { TooltipsModule} from "ionic-tooltips";
import { ModalModule} from "ngx-bootstrap";
// Import components
@NgModule({
  declarations: [
      CallbackPipe,
      OnlyNumber,
      RelativeTime
  ],
  imports: [
      AppSharedLibsModule,
      IonicTimepickerModule,
      SweetAlert2Module.forRoot({
          buttonsStyling: false,
          customClass: 'modal-content',
          confirmButtonClass: 'btn btn-primary btn-default',
          cancelButtonClass: 'btn btn-outline btn-default'
      }),
      TooltipsModule.forRoot(),
      ModalModule.forRoot(),
      NgSelectModule
  ],
  exports:[
      CallbackPipe,
      AppSharedLibsModule,
      IonicTimepickerModule,
      SweetAlert2Module,
      TooltipsModule,
      OnlyNumber,
      RelativeTime,
      ModalModule,
      NgSelectModule
  ],
  providers: [
      {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
      },
      DatePipe
  ]
})
export class AppSharedModule {
 static forRoot() {
        return {
            ngModule: AppSharedModule
        };
    }
}
